import { useEffect, useRef, useState } from "react";
import styles from "../styles/lift.module.css";

const medalHexes = {
    deadlift: ["0x53", "0x54", "0x52"],
    squat: ["0x4F", "0x4E", "0x47"],
    bench: ["0x4D", "0x41", "0x4E"],
};


export default function Lift({ lift, goBack, numProblems=4}) {
    const [timeLeft, setTimeLeft] = useState(4500);
    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");
    const [currentAnswer, setCurrentAnswer] = useState(null);
    const [started, setStarted] = useState(false);
    const [result, setResult] = useState(null);
    const [currentProblem, setCurrentProblem] = useState(0);
    const [showCorrect, setShowCorrect] = useState(false);
    const correct = useRef(0);
    const inputRef = useRef(null);

    useEffect(() => {
        if (!started) return;
        const timer = setInterval(() => {
            setTimeLeft((t) => {
                if (t <= 1) {
                    endGame(false);
                    return 0;
                }
                return t - 1;
            });
        }, 10);
        return () => clearInterval(timer);
    }, [started]);


    function startGame() {
        correct.current = 0;
        setResult(null);
        setTimeLeft(4500);
        setStarted(true);
        nextQuestion();

        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    }

    function nextQuestion() {
        const plates = [45, 35, 25, 10, 5];
        const bar = 45;
        const weightRanges = {
            deadlift: [225, 600],
            squat: [155, 500],
            bench: [95, 400],
        };
        const [minWeight, maxWeight] = weightRanges[lift];
        let totalWeight = Math.floor(Math.random() * (maxWeight - minWeight + 1)) + minWeight;
        totalWeight = Math.max(totalWeight, bar);

        let remainingSide = (totalWeight - bar) / 2;
        const platesOnSide = [];
        for (let p of plates) {
            while (remainingSide >= p) {
                platesOnSide.push(p);
                remainingSide -= p;
            }
        }

        const plateStr = platesOnSide.length ? " + " + platesOnSide.join(" + ") : "";
        setQuestion(`Bar${plateStr} each side = ?`);
        const sideTotal = platesOnSide.reduce((a, b) => a + b, 0);
        setCurrentAnswer(bar + 2 * sideTotal);
        setAnswer("");
    }


    function checkAnswer() {
    if (parseInt(answer) === currentAnswer) {
        correct.current++;

        // Show the "Correct!" message briefly
        setShowCorrect(true);
        setTimeout(() => setShowCorrect(false), 800);

        if (currentProblem + 1 >= numProblems) {
            // All problems done
            endGame(true);
        } else {
            setCurrentProblem((prev) => prev + 1);
            nextQuestion();
        }
    } else {
        setQuestion(`❌ Correct Answer: ${currentAnswer}`);
        setTimeout(nextQuestion, 800);
    }
}


    function endGame(success) {
        setStarted(false);
        if (success) {
            setResult({ success: true });
        } else {
            setResult({ success: false });
        }
    }

    const seconds = Math.floor(timeLeft / 100);
    const hundredths = timeLeft % 100;

    return (
        <>
        <button className={styles.backBtn} onClick={goBack}>← Back</button>
        <h1>{lift?.toUpperCase()}</h1>

        {!result ? (
        <div className={styles.gameCenter}>
            {!started && <button onClick={startGame}>Start</button>}

            {started && (
            <>
                <div>Time: {seconds}.{hundredths.toString().padStart(2, "0")}</div>
                <div>{question}</div>

                {showCorrect && <div className={styles.correctFlash}>Correct!</div>}
                
                <input
                ref={inputRef}
                className={timeLeft <= 500 ? styles.danger : ""}
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                    e.preventDefault();
                    checkAnswer();
                    }
                }}
                />

                <button onClick={checkAnswer}>Submit</button>
            </>
            )}
        </div>
        ) : (
        <div className={styles.resultScreen}>
            {result.success ? (
            <>
                <h2>Congratulations!</h2>
                <p>You caught up on the {lift} platform.</p>

                <div className={styles.medals}>
                {medalHexes[lift].map((hex, i) => (
                    <div
                    key={i}
                    className={`${styles.medal} ${styles[["gold","silver","bronze"][i]]}`}
                    >
                    {hex}
                    </div>
                ))}
                </div>
            </>
            ) : (
            <>
                <h2>Time's Up!</h2>
                <button onClick={startGame}>Try Again</button>
            </>
            )}
        </div>
        )}

        </>
    );
}